/**
 * Playback rules per sound: max simultaneous instances (poly), priority for the global voice
 * budget (0 drop first … 3 never drop), minimum retrigger gap (cooldown, s) and an optional
 * music duck [amount, seconds] for big moments.
 */
export interface SfxMeta {
  poly?: number;
  priority?: number;
  cooldown?: number;
  duck?: [number, number];
}

export const SFX_META: Record<string, SfxMeta> = {
  ui_hover: { poly: 2, cooldown: 0.03 },
  ui_click: { poly: 3 },
  ui_back: { poly: 2 },
  ui_open: { poly: 2 },
  absorb: { poly: 4, cooldown: 0.02 },
  eat_big: { poly: 2 },
  eat_plant: { poly: 3 },
  bite: { poly: 3 },
  hit: { poly: 4, priority: 2 },
  hurt: { poly: 2, priority: 3 },
  death: { poly: 1, priority: 3 },
  impact: { poly: 3, priority: 2 },
  crumble: { poly: 2 },
  thunder: { poly: 1, priority: 2 },
  dash: { poly: 2 },
  jump: { poly: 2 },
  land: { poly: 2 },
  footstep: { poly: 3, cooldown: 0.06 },
  swim: { poly: 2, cooldown: 0.08 },
  splash: { poly: 2 },
  bubble: { poly: 5, cooldown: 0.02 },
  wing_flap: { poly: 3, cooldown: 0.05 },
  throw: { poly: 2 },
  growth: { poly: 1, priority: 3, duck: [0.55, 1.1] },
  evolve_ready: { poly: 1, priority: 3, duck: [0.35, 1.2] },
  evolve: { poly: 1, priority: 3, duck: [0.75, 3.2] },
  trait: { poly: 1, priority: 2 },
  powerup: { poly: 2, priority: 2 },
  warning: { poly: 1, priority: 2, cooldown: 0.4 },
  portal: { poly: 1, priority: 2 },
  ending: { poly: 1, priority: 3 },
  boss_roar: { poly: 1, priority: 3 },
  roar: { poly: 2, priority: 2 },
  chirp: { poly: 3, cooldown: 0.03 },
  screech: { poly: 2, priority: 2 },
  howl: { poly: 2, priority: 2 },
  hoot: { poly: 3 },
  sting: { poly: 3, priority: 2 },
  zap: { poly: 3, priority: 2 },
  sonar: { poly: 2 },
  whale_song: { poly: 2, priority: 2 },
  burp: { poly: 1, priority: 2 },
  fire: { poly: 2 },
  stoop: { poly: 1, cooldown: 0.6 },
  thermal: { poly: 1, cooldown: 0.8 },
  charge: { poly: 1, priority: 2 },
  tongue: { poly: 2 },
  jelly_pulse: { poly: 3 },
  human_knap: { poly: 3 },
  human_trumpet: { poly: 1, priority: 2 },
  human_cackle: { poly: 2 },
  human_crackle: { poly: 2 },
};
